import React from 'react';
import { Coffee, Sparkles, Utensils, Award } from 'lucide-react';
import DigitalMenu from '../../../components/DigitalMenu';

const LandingView = ({ tenant, menuData, onStartVisit, t }) => (
    <div style={{ minHeight: '100vh', background: 'var(--bg-main)', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', position: 'sticky', top: 0, background: 'rgba(var(--bg-main-rgb), 0.8)', backdropFilter: 'blur(10px)', zIndex: 100 }}>
            {tenant?.theme?.logoUrl && <img src={tenant.theme.logoUrl} alt="Logo" style={{ height: '32px' }} />}
            <div style={{ fontSize: '1.25rem', fontWeight: 800, color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: '1px' }}>{tenant?.name || 'CRM'}</div>
        </div>

        <div style={{ padding: '0 1rem 5rem' }}>
            <div className="card-premium" style={{ margin: '1rem 0 2rem', padding: '2rem', background: `linear-gradient(135deg, var(--primary) 0%, var(--primary-dark, #3e2723) 100%)`, color: 'white', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: -20, right: -20, opacity: 0.2 }}><Coffee size={120} /></div>
                <Sparkles style={{ position: 'absolute', top: 20, left: 20, opacity: 0.5 }} size={24} />
                <h2 style={{ fontSize: '1.75rem', fontWeight: 800, marginBottom: '1rem', position: 'relative' }}>{t('checkin.giftTitle')}</h2>
                <p style={{ fontSize: '1.125rem', opacity: 0.9, marginBottom: '2rem' }}>{t('checkin.giftSubtitle')}</p>
                <button onClick={onStartVisit} style={{ background: 'white', color: 'var(--primary)', padding: '1rem 2.5rem', fontWeight: 800, borderRadius: '14px' }}>{t('checkin.joinNow')}</button>
            </div>

            <div style={{ marginBottom: '2rem' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: '1rem', marginTop: '1rem' }}>
                    <div style={{ width: '50px', height: '3px', background: 'var(--primary)', borderRadius: '2px', marginBottom: '1rem', opacity: 0.9 }}></div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                        <Utensils size={18} color="var(--primary)" style={{ opacity: 0.85 }} />
                        <h3 style={{ fontSize: '1.5rem', fontWeight: 900, textTransform: 'uppercase', letterSpacing: '3px', color: 'var(--text-main)', margin: 0 }}>
                            {menuData?.menuName || 'MENÜ'}
                        </h3>
                        <Utensils size={18} color="var(--primary)" style={{ opacity: 0.85 }} />
                    </div>
                </div>
                <DigitalMenu
                    menuData={menuData}
                    tenant={tenant}
                    primaryColor="var(--primary)"
                    hideHeader={true}
                    tenantPlan={((tenant?.plan === 'pro' || tenant?.plan === 'premium') && tenant?.theme?.portalOrderingEnabled !== false) ? (tenant?.plan || 'pro') : 'free'}
                />
            </div>
        </div>

        <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, padding: '1.25rem', background: 'rgba(var(--bg-main-rgb), 0.8)', backdropFilter: 'blur(20px)', zIndex: 1000, display: 'flex', justifyContent: 'center' }}>
            <button onClick={onStartVisit} style={{ width: '100%', maxWidth: '400px', background: 'var(--primary)', color: 'white', height: '56px', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                {t('checkin.startVisit')} <Award size={20} />
            </button>
        </div>
    </div>
);

export default LandingView;
